import {
  anUpdateFirstSeenRule,
  mockUpdateFirstSeenRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import {
  ruleBuilderQuery_firstSeen,
  updatedFirstSeenRuleData,
} from '../queries/RuleBuilderQueryOperation.mocks';

export const updateFirstSeenRuleResponse = {
  __typename: 'Mutation',
  updateFirstSeenRule: anUpdateFirstSeenRule({
    data: { ...ruleBuilderQuery_firstSeen.rule, ...updatedFirstSeenRuleData },
  }),
};

export const handlers = [
  mockUpdateFirstSeenRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        // @ts-ignore windowSizeInMilliseconds is aliased which causes issues with typing since MSW doesn't handle this case
        data: updateFirstSeenRuleResponse,
      });
    }
  ),
];
